import React from 'react';
import { AdLandingTemplate } from '../../components/templates/AdLandingTemplate';
import { Shield, Target, Zap, Heart } from 'lucide-react';
export function MartialArtsNearMe() {
  return <AdLandingTemplate h1="Martial Arts Classes Near Farmington Hills" subheadline="Discover a structured, supportive martial arts program at Storm Taekwondo. We offer beginner-friendly classes for kids, adults, and families in the Farmington Hills area." ctaText="Claim Your Free Trial Week" searchIntent="Martial Arts Near You" heroImage="https://images.unsplash.com/photo-1599058917212-d750089bc07e?auto=format&fit=crop&w=1200&q=80" benefits={[{
    icon: Shield,
    title: 'Self-Defense Skills',
    description: 'Learn practical fundamentals to protect yourself and build confidence.'
  }, {
    icon: Target,
    title: 'Mental Discipline',
    description: 'Develop focus and resilience through structured martial arts training.'
  }, {
    icon: Zap,
    title: 'Physical Fitness',
    description: 'A dynamic, full-body workout that improves strength and agility.'
  }, {
    icon: Heart,
    title: 'Family-Friendly',
    description: 'A welcoming environment for students of all ages and experience levels.'
  }]} whatYouLearn={['Core martial arts stances, blocks, and strikes', 'Dynamic kicking techniques unique to Taekwondo', 'How to set and achieve long-term goals', 'Respect, courtesy, and self-control', 'Improved physical coordination and flexibility']} faqs={[{
    question: 'What style of martial arts do you teach?',
    answer: 'We teach Olympic-style Taekwondo, a dynamic martial art known for its powerful kicking techniques, discipline, and focus.'
  }, {
    question: 'Is it safe for beginners?',
    answer: 'Absolutely. Safety is our top priority. Our experienced coaches ensure a structured, controlled environment where beginners can learn at their own pace.'
  }, {
    question: 'Do I need to be in shape to start?',
    answer: 'Not at all! Martial arts is a great way to get in shape. Our classes are designed to help you build fitness gradually as you learn the techniques.'
  }, {
    question: 'Can my whole family train together?',
    answer: 'Yes! We offer specific Family Classes where parents and children can train on the same mat, making it a great shared activity.'
  }]} metaTitle="Martial Arts Near Me | Farmington Hills | Storm Taekwondo" metaDescription="Searching for martial arts near Farmington Hills? Storm Taekwondo provides beginner-friendly classes for kids, adults, and families. Try a free week today." data-id="element-603" />;
}